/* eslint-disable no-unused-vars */
/**
 * Replica of ObituaryType.php
 */
var ObituaryType;
(function (ObituaryType) {
    /**
     * Basisvermelding
     */
    ObituaryType[ObituaryType["Basic"] = 1] = "Basic";
    /**
     * Normale advertentie
     */
    ObituaryType[ObituaryType["Regular"] = 0] = "Regular";
    /**
     * Uitgebreid (voorheen herdenkingspagina)
     */
    ObituaryType[ObituaryType["Extended"] = 2] = "Extended";
})(ObituaryType || (ObituaryType = {}));
export default ObituaryType;
